import { useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";
import { getIsInDetachMode } from "src/duck/selectors";
import { VideoErrorType } from "src/modules/parent-station/lib/createVideoErrorManager";
import BlinkingDot from "./BlinkingDot";
import { getAppValue } from "src/utils/environment";
import { ReactComponent as WarningIcon } from "./warning.svg";
import VideoIsSlowDialog from "./VideoIsSlowDialog";

export default function VideoIndicator({ videoError }) {
  const isInDetachMode = useSelector(getIsInDetachMode);

  const [renderVideoIsSlowDialog, setRenderVideoIsSlowDialog] = useState();

  const closeVideoIsSlowDialog = () => setRenderVideoIsSlowDialog(false);
  const openVideoIsSlowDialog = () => {
    if (isInDetachMode) return;
    setRenderVideoIsSlowDialog(true);
  };
  return (
    <>
      <VideoIsSlowDialog
        isOpen={renderVideoIsSlowDialog}
        onDismiss={closeVideoIsSlowDialog}
      />
      {videoError === null && (
        <BlinkingDot
          bg={getAppValue({
            barkio: "primaryLighter",
            bibino: "secondary"
          })}
        />
      )}
      {videoError === VideoErrorType.SLOW && (
        <Box
          bg="black20"
          p="8px"
          position="relative"
          borderRadius="100%"
          onClick={openVideoIsSlowDialog}
        >
          <SvgContainer icon={WarningIcon} size="16px" fill="white" />
          <Box position="absolute" bottom="0px" left="0px">
            <BlinkingDot bg="warningBase" />
          </Box>
        </Box>
      )}
    </>
  );
}
